/**
 * Cache Utility & Auto-Purge Service
 * Manages cache sanitization while preserving active authentication sessions,
 * 2FA verification tokens, and user preferences.
 */

const CURRENT_CACHE_VERSION = 'rb-cache-v2';

export async function autoClearSiteCache(): Promise<void> {
  try {
    if (typeof window === 'undefined') return;

    // Check version to only run cache bust once per version upgrade
    const storedVersion = localStorage.getItem('rb_app_cache_version');
    if (storedVersion === CURRENT_CACHE_VERSION) {
      return;
    }

    // Purge only outdated cache storage buckets without destroying the active PWA worker
    if ('caches' in window) {
      const cacheKeys = await window.caches.keys();
      for (const key of cacheKeys) {
        if (!key.includes('workbox-precache') && key !== CURRENT_CACHE_VERSION) {
          try {
            await window.caches.delete(key);
          } catch {}
        }
      }
    }

    // Mark current cache version as verified
    localStorage.setItem('rb_app_cache_version', CURRENT_CACHE_VERSION);
  } catch (err) {
    // Silent fail-safe
  }
}

